import React from "react";
import {
  ModalOverlay,
  ModalContent,
  ModalTitle,
  FormatButton,
  CloseButton,
  ButtonsContainer,
} from "./index.styled";
import closeIcon from "../../../assets/icons/close.webp";

export type ExportFormat = "csv" | "vcf";

interface ExportFormatModalProps {
  isOpen: boolean;
  onClose: () => void;
  onFormatSelect: (format: ExportFormat) => void;
}

const ExportFormatModal: React.FC<ExportFormatModalProps> = ({
  isOpen,
  onClose,
  onFormatSelect,
}) => {
  if (!isOpen) return null;

  const handleFormatSelect = (format: ExportFormat) => {
    onFormatSelect(format);
    onClose();
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <ModalContent>
        <CloseButton onClick={onClose}>
          <img src={closeIcon} alt="close" />
        </CloseButton>

        <ModalTitle>בחר פורמט ייצוא</ModalTitle>

        <ButtonsContainer>
          <FormatButton onClick={() => handleFormatSelect("csv")} $format="csv">
            <span>CSV</span>
          </FormatButton>

          <FormatButton onClick={() => handleFormatSelect("vcf")} $format="vcf">
            <span>VCF</span>
          </FormatButton>
        </ButtonsContainer>
      </ModalContent>
    </ModalOverlay>
  );
};

export default ExportFormatModal;
